export default __webpack_public_path__ + "static/media/cabourg19.d7a3e108.jpg";